import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FoodGuideState } from './food-guide.reducer';

const foodGuideData =
  createFeatureSelector<FoodGuideState>('ss-cord.food-guide');

export const foodGuideList = createSelector(
  foodGuideData,
  (state: FoodGuideState) => state.foodGuideList
);

export const selectedItem = createSelector(
  foodGuideData,
  (state: FoodGuideState) => state.selectedItem
);

export const selectedItemLoading = createSelector(
  foodGuideData,
  (state: FoodGuideState) => state.selectedItemLoading
);

export const auditHistory = createSelector(
  foodGuideData,
  (state: FoodGuideState) => state.auditHistory
);

export const saving = createSelector(
  foodGuideData,
  (state: FoodGuideState) => state.saving
);

export const retiring = createSelector(
  foodGuideData,
  (state: FoodGuideState) => state.retiring
);

export const foodCategories = createSelector(
  foodGuideData,
  (state: FoodGuideState) => state.foodCategories
);
